import { useState } from "react";

export const useExchangeItemForm = () => {
  const [formData, setFormData] = useState({
    grossWeight: "",
    netWeight: "",
    stoneWeight: "0",
    purity: "22K",
    color: "YELLOW",
    condition: "GOOD",
    notes: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));

    // Clear error for this field
    if (errors[key]) {
      setErrors((prev) => ({
        ...prev,
        [key]: null,
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.grossWeight || parseFloat(formData.grossWeight) <= 0) {
      newErrors.grossWeight =
        "Gross weight is required and must be greater than 0";
    }

    if (!formData.netWeight || parseFloat(formData.netWeight) <= 0) {
      newErrors.netWeight = "Net weight is required and must be greater than 0";
    }

    if (parseFloat(formData.netWeight) > parseFloat(formData.grossWeight)) {
      newErrors.netWeight = "Net weight cannot be greater than gross weight";
    }

    if (parseFloat(formData.stoneWeight) < 0) {
      newErrors.stoneWeight = "Stone weight cannot be negative";
    }

    if (!formData.purity) {
      newErrors.purity = "Purity is required";
    }

    if (!formData.condition) {
      newErrors.condition = "Condition is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (onSubmit) => {
    if (validate()) {
      onSubmit(formData);
    }
  };

  return {
    formData,
    setFormData,
    errors,
    handleChange,
    validate,
    handleSubmit,
  };
};
